import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { FreeTrialDialog } from 'components/shared/free-trial-dialog';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import dashedButtonStyle from 'styles/buttons/dashed-button.module.scss';
import { TestimonialCarousel } from './testimonial-carousel';
import { TestimonialsDialog } from './testimonials-dialog';

export interface TestimonialsProps {
    maxTestimonials?: number;
    builderType: string;
    readonly?: boolean;
    isFree?: boolean | null;
}

export const Testimonials = ({ maxTestimonials = 5, builderType, readonly = false, isFree = null }: TestimonialsProps) => {
    const [dialog, setDialog] = useState(false);
    const [freeTrialDialog, setFreeTrialDialog] = useState(false);
    const builderData = useSelector(GetUrlBuilderData);

    const openDialog = () => {
        setDialog(true);
    };

    const handleDialogClose = () => setDialog(false);

    const openFreeTrialDialog = () => setFreeTrialDialog(true);
    const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);
    return (
        <Grid item container xs={12}>
            {builderData.testimonials.length > 0 && (
                <Grid item xs={12} style={{ paddingBottom: '2em' }}>
                    <TestimonialCarousel testimonials={builderData.testimonials} color={builderData.primaryColor.color} cardId={builderData.cardId} builderType={builderType} readonly={readonly} isFree={isFree} />
                </Grid>
            )}
            {builderData.testimonials.length < maxTestimonials && !readonly && (
                <Grid item xs={12}>
                    <Button onClick={!isFree ? openDialog : openFreeTrialDialog} classes={{ root: dashedButtonStyle.root }} fullWidth>
                        <AddIcon /> Add Testimonial
                    </Button>
                </Grid>
            )}
            {dialog && <TestimonialsDialog isOpen={dialog} onClose={handleDialogClose} builderType={builderType} />}
            {freeTrialDialog && <FreeTrialDialog isOpen={freeTrialDialog} onClose={handleCloseFreeTrialDialog} />}
        </Grid>
    );
};
